module.exports = __webpack_public_path__ + "static/media/logo2.2002bc3e.jpg";